import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WatchDirective } from './watch.directive';



@NgModule({
  declarations: [
    WatchDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    WatchDirective
  ]
})
export class MvcDirectivesModule { }
